module.exports = __webpack_public_path__ + "static/media/undraw_privacy_protection_nlwy 1.42d4bde7.svg";